/** @format */

import React from "react";
import { ReactComponent as XCircle } from "bootstrap-icons/icons/x-circle.svg";
import { qualIdToFull } from "../../../utils/functions";
import { useLocale } from "../../../i18n/hooks";
import { useTranslation } from "react-i18next";
import { QueryProps } from "../resourceIndexUI/ResourcesIndexUI";
import { SpecItemData } from "../../../types";
import QueryItem from "./QueryItem";

type Props = {
  query: QueryProps;
  handleClearClick: () => void;
  handleQueryItemClick: (
    thisValue: string,
    thisQueryType: keyof QueryProps,
  ) => void;
  specItems?: SpecItemData;
};

const ResourceCurrentFilter: React.FC<Props> = ({
  query,
  handleClearClick,
  handleQueryItemClick,
  specItems,
}) => {
  const locale = useLocale();
  const { t: _ } = useTranslation();

  const getSpecTitle = (specItem: any[], specIndex: string[]): string => {
    try {
      const _specIndex = [...specIndex];
      const index = parseInt(_specIndex.pop() ?? "0");
      if (_specIndex.length > 0) {
        return getSpecTitle(specItem[index].children, _specIndex);
      } else {
        return specItem[index].title[locale];
      }
    } catch {
      return "error";
    }
  };

  return (
    <div className="mb-3 current-tags">
      {(query.types.length > 0 ||
        query.tags.length > 0 ||
        query.level ||
        query.specItem ||
        query.qualification ||
        query.cats.length > 0) && (
        <button
          onClick={() => handleClearClick()}
          className="btn btn-lg btn-danger float-end mb-2"
        >
          {_("Reset filter")}&ensp;
          <XCircle />
        </button>
      )}

      {query.tags.length === 0 &&
        query.types.length === 0 &&
        !query.level &&
        query.cats.length === 0 &&
        !query.qualification && (
          <span className="d-none d-sm-inline-block btn btn-lg btn-light shadow disabled me-2 tag mb-2">
            {_("No Tags Selected")}
          </span>
        )}

      {
        /** Function to iterate through each filter type and output the selected items for each param */
        Object.keys(query)
          // If no specItems attached to subject then hide "selected" specItems
          .filter((key) => !(!specItems && key === "specItem") && key !== "sort")
          .map((key) => {
            let queryKey = key as keyof QueryProps;
            let queryValue = query[queryKey];
            // Check value was selected for that param
            if (queryValue !== undefined) {
              // If it is possible to select more than one value for param then output all selected
              if (Array.isArray(queryValue)) {
                return queryValue.sort().map((element, index) => (
                  <QueryItem
                    key={element + index}
                    onClick={() => handleQueryItemClick(element, queryKey)}
                  >
                    {element}&ensp;
                  </QueryItem>
                ));
              } else {
                return (
                  <QueryItem
                    key={key}
                    onClick={() =>
                      handleQueryItemClick(queryValue as string, queryKey)
                    }
                  >
                    {
                      // Depending on param type output readable value
                      queryKey === "qualification"
                        ? _(qualIdToFull(query.qualification))
                        : queryKey === "specItem"
                          ? getSpecTitle(
                              (specItems as SpecItemData).spec,
                              queryValue.split(".").reverse(),
                            )
                          : queryValue
                    }
                    &ensp;
                  </QueryItem>
                );
              }
            } else {
              return null;
            }
          })
      }
    </div>
  );
};

export default ResourceCurrentFilter;
